import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { KoText, KoTitle } from "packages/typography";
import { KoAssertsView, KoButton, KoCheckBox, KoDateFormatter, KoDrawer, KoDropdown,KoImage, KoRichTextEditorReadOnly, KoToast } from "packages";
import KoIcon from '@kwapio/icons';
import { fixSlateDocument, formatFileSize, getDrivePermission } from "shared/utils";
import { getCookie } from "shared/utils/cookies";
import styles from './files.module.scss';
import FileTypeIcon from "./fileTypeIcon";
import { FilesAPI } from "../files.service";
import Comments from "../comments";
import FileSharePanel from "../fileSharePanel";
import { downloadFile } from "../downloaddocx";

function FileInfo(props) {
  const { data, row, onCellClick, options, colName, onMouseEnter, handelFileActions, onDocxSelection, selectedDocx, highlighted } = props;
  const [onFileOpen, setOnFileOpen] = React.useState(false);
  const [fileDetails, setFileDetails] = useState(row);
  const [isOpenCommentsModalNew, setCreateCommentNew] = useState(false);
  const [openComments, setOpenComments] = useState(false);
  const [openSharing, setOpenSharing] = useState(false);
  const [savingTextStatus, setSavingTextStatus] = useState('');
  const [isLoading, setLoading] = useState(false);
  const [totalComments, setCommentsTotal] = useState(0);

  useEffect(() => {
    if (row) {
      console.log('row', row);
      setFileDetails(row);
    }
  }, [row]);

  const onUpdateName = (name) => {
    FilesAPI.renameDocument({ name }, fileDetails?.documentId).then(
      (data) => {
        KoToast.success(`Document renamed successfully!`);
      },
      (err) => {
        KoToast.error(`error`);
      }
    );
  };

  const getFIleById= (id) => {
    FilesAPI.getFileById(id).then(
      (data) => {
        setFileDetails(data['file']);
      },
      (err) => {
        KoToast.error(`error`);
      }
    );
  };


  const getComments = (documentId) => {
    setLoading(true);
    if(!documentId) return;
    FilesAPI.getComments(documentId).then(
      (data) => {
        setLoading(false);
        setCommentsTotal(data?.totalCount);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const handleFileShareFinish = (values => {
    let obj = {
      documentId: [fileDetails?.documentId],
      ...values,
      name: 'file'
    };
  
    FilesAPI.fileShare(obj).then(
      (data) => {
        getFIleById(fileDetails?.documentId);
        KoToast.success(`Access granted successfully!`);
      },
      (err) => {
        KoToast.error(`Please try again`);
      }
    );
  });
  const permission = getDrivePermission(fileDetails?.sharedWith, getCookie('userId'), fileDetails?.createdBy);
  const fixedContent = fixSlateDocument(fileDetails?.shortText);
  return (
    <div className={`profileChar ${styles.wrapper}`} onMouseEnter={() => onMouseEnter && onMouseEnter()}>
      <div className={`${styles.membersWrapper} ${(selectedDocx?.includes(fileDetails.documentId) || highlighted) ? styles.membersWrapperactive : ''}`} onClick={() => onCellClick && onCellClick(fileDetails, colName)}>
        {(fileDetails?.type?.includes('docx') || fileDetails?.type?.includes('whiteboard')) ? <Link to={`/open/document/${fileDetails?.folderId ? fileDetails?.folderId: 'root'}/${fileDetails?.documentId}`} target="_blank">
          <div className={`${styles.fileInfoWrapper} `}>
            <FileTypeIcon type={fileDetails?.type} />
            <div className={styles.memberInfo}>
              <KoText ellipsis={true} text={`${data}`} className={`${styles.memberName}`} />
            </div>
          </div>
          <div className={styles.content}>
            <div className={styles.asserts}>
              {
                fileDetails?.type?.includes('docx') &&
              <KoRichTextEditorReadOnly
                className={styles.docx}
                initialValues={fixedContent ? fixedContent : [{ type: 'paragraph', children: [{ text: 'No content available.' }] }]}
              />
              }
              {fileDetails?.type?.includes('whiteboard') && <div className={styles.whiteboard}>
                <div
                  style={{
                    height: '100%',
                    width: '17rem',
                    background: fileDetails?.shortText[0].thumbnail
                      ? `url(${fileDetails?.shortText[0].thumbnail}) center/contain no-repeat`
                      : "#eee",
                    cursor: "pointer"
                  }}
                />
              </div>}
            </div>
          </div>
          <div className={styles.footer}>
            {fileDetails?.size ? <KoText text={`${formatFileSize(fileDetails?.size)}`} className={styles.email} /> : ''}
            <div className={styles.date}>
              <KoText text={`Updated: `} className={styles.email} />
              <KoDateFormatter format="DD-MM-YYYY" className={styles.email} data={fileDetails?.updatedAt && fileDetails?.updatedAt !== '0001-01-01T00:00:00Z' ? fileDetails?.updatedAt : fileDetails?.createdAt} />
            </div>
          </div>
        </Link> : <div className={`${styles.aTga} `} onClick={(e) => setOnFileOpen(true)}>
          <div className={`${styles.fileInfoWrapper} `}>
            <FileTypeIcon type={fileDetails?.type} />
            <div className={styles.memberInfo}>
              <KoText ellipsis={true} text={`${data}`} className={`${styles.memberName}`} />
            </div>
          </div>
          <div className={styles.content}>
            <div className={styles.asserts}>
              {fileDetails?.type?.includes('image') && <KoImage src={fileDetails?.url} preview={false}
                style={{ width: '22.6rem', height: '14.4rem', objectFit: 'contain' }} />}
              {fileDetails?.type?.includes('video') &&
              <video
                src={fileDetails?.url}
                width='226'
                height='144'
                controls={false}
              />}
              {fileDetails?.type?.includes('video') && <div className={styles.videoPlay}>
                <KoIcon width={60} height={60} name={'PlayOutlined'} color={'#FFFFFF'} />
              </div>}
              {fileDetails?.type?.includes('pdf') && <div className={styles.videoPlay}>
              </div>}
              {fileDetails?.type?.includes('audio') && <div className={styles.videoPlay}>
                <KoIcon width={60} height={60} name={'AudioOutlined'} color={'#FFFFFF'} />
              </div>}
              
              {
                fileDetails?.type?.includes('pdf') &&
              <iframe
                src={fileDetails?.url}
                width='226'
                height='144'
                style={{ border: "none" }}
                title="Document Preview"
              />
              }
            </div>
          </div>
          <div className={styles.footer}>
            {fileDetails?.size ? <KoText text={`${formatFileSize(fileDetails?.size)}`} className={styles.email} /> : ''}
            <div className={styles.date}>
              <KoText text={`Updated: `} className={styles.email} />
              <KoDateFormatter format="DD-MM-YYYY" className={styles.email} data={fileDetails?.updatedAt && fileDetails?.updatedAt !== '0001-01-01T00:00:00Z' ? fileDetails?.updatedAt : fileDetails?.createdAt} />
            </div>
          </div>
        </div>}
      </div>
      {onDocxSelection && <div className={`${styles.checkboxActions} size18 ${selectedDocx?.includes(fileDetails.documentId) ? styles.active : ''}`}>
        <KoCheckBox
          onChange={() => onDocxSelection(fileDetails.documentId)}
          checked={selectedDocx?.includes(fileDetails.documentId)}
        />
      </div>}
      <KoDropdown
        overlayClassName={styles.settings}
        popupRender={(menu) => (
          <div className={styles.customDropdown} >
            <div className={styles.customDropdownContnet}>
              <ul>
                {options.includes('rename') && permission.canEdit && (
                  <li onClick={() => handelFileActions(fileDetails, 'rename')}>
                    <KoIcon name={'EditOutlined'} />
                    <KoText text={'Rename'} />
                  </li>
                )}

                {options.includes('share') && permission.canEdit && (
                  <li onClick={() => handelFileActions(fileDetails, 'share')}>
                    <KoIcon name={'AddtoGroupsOutlined'} color={'#FF0000'} />
                    <KoText text={'Share'} />
                  </li>
                )}

                {options.includes('move') && permission.canEdit && (
                  <li onClick={() => {
                    handelFileActions(fileDetails, 'move');
                    onDocxSelection && onDocxSelection(fileDetails.documentId);
                  }}>
                    <KoIcon name={'MoveToOutlined'} />
                    <KoText text={'Move to'} />
                  </li>
                )}

                {options.includes('linkToWorkspace') && permission.canEdit && (
                  <li onClick={() => handelFileActions(fileDetails, 'linkToWorkspace')}>
                    <KoIcon name={'WorkspaceOutlined'} color={'#FF0000'} />
                    <KoText text={'Link to Workspace'} />
                  </li>
                )}

                {options.includes('star') && (
                  <li onClick={() => handelFileActions(fileDetails, 'star')}>
                    <KoIcon name={'StarOutlined'} color={fileDetails.isStarred ? 'var(--query)' : ''} />
                    <KoText text={fileDetails.isStarred ? 'Unstar' : 'Star'} />
                  </li>
                )}

                {options.includes('download') && (
                  <li onClick={() => handelFileActions(fileDetails, 'download')}>
                    <KoIcon name={'DownloadOutlined'} />
                    <KoText text={'Download'} />
                  </li>
                )}

                {options.includes('delete') && permission.canEdit && (
                  <li onClick={() => handelFileActions(fileDetails, 'delete')}>
                    <KoIcon name={'DeleteOutlined'} color={'#FF0000'} />
                    <KoText text={'Delete'} />
                  </li>
                )}
              </ul>
            </div>
          </div>
        )}
        placement={'bottomRight'}>
        <KoButton type='text' icon={<KoIcon name="VerticalMenuOutlined" width={18} height={18} />} className={`${styles.btn} smallBtn`} />
      </KoDropdown>
      {onFileOpen && <KoAssertsView
        openFileCreate={onFileOpen}
        showComments={false}
        fileName={fileDetails?.name}
        canEdit={permission?.canEdit}
        fileDetails={row}
        totalComments={totalComments}
        canComment={permission?.canComment}
        canView={permission?.canView}
        getComments={()=>getComments(fileDetails?.documentId)}
        onUpdateName={onUpdateName}
        isLoading={isLoading}
        actions={['download', 'comments', 'share', 'updated']}
        savingTextStatus={savingTextStatus}
        setOpenFileCreate={setOnFileOpen}
        onDownload={() => {downloadFile(fileDetails?.url, fileDetails?.name, setLoading, setSavingTextStatus('Downloading...'));
        }}
        onComments={() => setOpenComments(true)}
        onShare={() => setOpenSharing(true)}


        documentId={fileDetails?.documentId} />}
      <KoDrawer
        placement="right"
        closable={false}
        title={
          <div className={styles.headerTitle}>
            <KoTitle text={'Comments'} level={4} className={styles.title} />
            <KoButton type='primary' icon={<KoIcon color="#FFF" width={18} height={18} name={'PlusOutlined'} />} label={'Add a Comment'} onClick={() => setCreateCommentNew(true)} />
          </div>
        }
        onClose={() => setOpenComments(false)}
        open={openComments}
        width={750}
        footer={false}
      >
        {(fileDetails?.documentId && (permission.canEdit || permission.canComment)) && <Comments updateCount={()=>getComments(fileDetails?.documentId)}  emptyRowHeight={`${styles.wrapperOverflow} `} documentId={fileDetails?.documentId} setCreateComment={setCreateCommentNew} isOpenCommentsModal={isOpenCommentsModalNew} />}
      </KoDrawer>
      {openSharing && <FileSharePanel
        title={`${row?.name}`}
        onClose={() => setOpenSharing(false)}
        initialShared={fileDetails?.sharedWith}
        onSave={(sharedWith) => {
          handleFileShareFinish({ sharedWith: sharedWith });
        }}
      />}
    </div>
  );
}
export default FileInfo;
